export default [
  {
    text: 'Actions',
    value: 'actions',
    align: 'right',
    sortable: false,
    order: 0,
    hidable: false,
    hidden: false,
    width: '92px',
  },
  {
    text: 'File',
    value: 'fileName',
    order: 1,
    sortable: true,
    hidable: true,
    hidden: false,
    width:'200px'
  },
    {
      text: 'Number',
      value: 'documentNumber',
      order: 1,
      sortable: true,
      hidable: true,
      hidden: false,
    },
    {
      text: 'Title',
      value: 'documentTitle',
      align: 'left',
      sortable: true,
      order: 2,
      hidable: true,
      hidden: false,
    },
    {
      text: 'Type',
      value: 'documentType',
      align: 'left',
      sortable: true,
      order: 3,
      hidable: true,
      hidden: false,
    },
  
    {
      text: 'Revision',
      value: 'revisionNumber',
      order: 6,
      hidable: true,
      hidden: false,
      sortable: false,
    },
    {
      text: 'UploadedBy',
      value: 'createdBy',
      order: 7,
      hidable: true,
      hidden: false,
      width:'200px',
      minWidth:'200px'
    },
    {
      text: 'UploadedOn',
      value: 'createDate',
      order: 8,
      hidable: true,
      hidden: false,
      width:'200px',
      minWidth:'200px'
    },

  ];
  